
import { Vue, Component } from 'vue-property-decorator';
import PushButtonMock from '@/ui/components/devices/previews/components/PushButtonMock.vue';
import ArrowButtonMock from '@/ui/components/devices/previews/components/ArrowButtonMock.vue';
import DeviceLayout from '@/ui/components/devices/components/DeviceLayout.vue';

@Component({
  components: {
    PushButtonMock,
    ArrowButtonMock,
    DeviceLayout,
  },
})
export default class PumpWithoutVFDPreview extends Vue {
  get mainViewLang() {
    return 'devices.PumpWithoutVFD.mainView';
  }
  get previewNameLang() {
    return this.$t('devices.PumpWithoutVFD.previewName');
  }
}
